import  { useState } from "react";
import { Formik } from "formik";
import { Form, Input, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { FlatButton } from "../Shared/FlatButton";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { UseDataContext } from "../Context/UseDataContext";
import { UseAuthContext } from "../Context/UseAuthContext";


const { Title, Text } = Typography;

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

type FormikValues = {
  email: string;
};

export default function AcceptAdmin() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const{dispatch} = UseDataContext();
  const {user} = UseAuthContext();

  const handleCreateAccount = async (
  values: FormikValues,
  { resetForm }: any
) => {
  setLoading(true);
  setError(null);
  setSuccess(false);

  try {
    const response = await fetch(
      "https://trinityarms.vercel.app/user/createUser",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify({
          type: "createadmin",
          email: values.email.trim().toLowerCase(),
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message || "Failed to create admin account."
      );
    }

    console.log("Admin created:", data);
    dispatch({type:'createadmin',payload:data});

    setSuccess(true);

    toast.success("Admin account created successfully!");

    resetForm();
  } catch (error) {
    console.error("Error creating admin:", error);

    const message =
      error instanceof Error
        ? error.message
        : "Failed to create admin account.";

    setError(message);

    toast.error(message);
  } finally {
    setLoading(false);
  }
};

  return (
    <Formik
      initialValues={{ email: "" }}
      validationSchema={validationSchema}
      onSubmit={handleCreateAccount}
    >
      {(formik) => (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#fff",
            padding: "30px",
            borderRadius: "10px",
            height: "100vh",
          }}
        >
          <div style={{ maxWidth: "600px", width: "100%" }}>
            <div style={{ position: "relative", textAlign: "right" }}>
              <CloseOutlined
                onClick={() => navigate("/admin_jctbdil1$")}
                style={{
                  fontSize: "24px",
                  padding: "10px",
                  border: "1px solid black",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            </div>

            <Title level={3}>Create Admin Account</Title>
            <Text type="secondary" style={{ fontSize: "14px" }}>
              Email will be used with a default admin password.
            </Text>
            <br />

            {error && <Text type="danger">{error}</Text>}
            {success && (
              <Text type="success">Admin account created successfully!</Text>
            )}

            <Form layout="vertical" onFinish={formik.handleSubmit}>
              <Form.Item
                label="Email"
                validateStatus={
                  formik.errors.email && formik.touched.email ? "error" : ""
                }
                help={formik.touched.email && formik.errors.email}
              >
                <Input
                  name="email"
                  placeholder="Enter email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Form.Item>

              <FlatButton
                title="Create Admin"
                onClick={formik.handleSubmit}
                disabled={loading}
                className="buttondark"
              />
            </Form>
          </div>
        </div>
      )}
    </Formik>
  );
}
